export default {
  data: {
    currTab: 0,
    jobs: {
      inspections: [],
      totalJobs: 0,
      totalDraft: 0,
      totalRecords: 0,
      startIndex: 1,
      endIndex: 10,
    },
    chartData: {},
    searchKeyword: '',
    filters: {
      jobStatus: '',
      dateOperator: 'between', // "between" || "before" || "after"
      from: '',
      to: '',
      locations: [
        {
          country: '',
          city: '',
        },
      ],
    },
    status: 'uninitialized',
    serviceProviders: {
      loading: false,
      data: [],
      error: null,
    },
    searchData: null,
  },
};
